import {
	collection,
	getDocs
}
from "firebase/firestore";

import {
	db
}
from "../firebase/firebaseConfig";

const generarPlanEstudio = async ({

	usuario,

	examenId,

	examen,

	componentes
}) => {

	const listaComponentes =
		Object.entries(componentes);

	const fortalezas =
		listaComponentes
			.filter(
				([, info]) =>
					info.temasEvaluados > 0
			)
			.sort(
				(a, b) =>
					b[1].temasEvaluados -
					a[1].temasEvaluados
			)
			.slice(0, 3)
			.map(
				([nombre]) => nombre
			);

	const oportunidades =
		listaComponentes
			.filter(
				([, info]) =>
					info.temasEvaluados === 0
			)
			.slice(0, 5)
			.map(
				([nombre]) => nombre
			);

	const temasExplorados =
		listaComponentes.reduce(
			(acc, [, info]) =>
				acc +
				(info.temasExplorados || 0),
			0
		);

	const temasDominados =
		listaComponentes.reduce(
			(acc, [, info]) =>
				acc +
				(info.temasEvaluados || 0),
			0
		);

		const [
			temasSnap,
			temaCompSnap,
			componentesSnap,
			progresoSnap
		] = await Promise.all([
		
			getDocs(
				collection(
					db,
					"materias_temas"
				)
			),
		
			getDocs(
				collection(
					db,
					"tema_componente"
				)
			),
		
			getDocs(
				collection(
					db,
					"componentes"
				)
			),
		
			getDocs(
				collection(
					db,
					"progreso_temas"
				)
			)
		]);	

		const temas =
	temasSnap.docs.map(
		d => d.data()
	);

const relaciones =
	temaCompSnap.docs.map(
		d => d.data()
	);

const componentesDB =
	componentesSnap.docs.map(
		d => d.data()
	);

const progresos =
	progresoSnap.docs
		.map(
			d => d.data()
		)
		.filter(
			p =>
			p.userId ===
			usuario.uid
		);

		const rutasSnap =
		await getDocs(
			collection(
				db,
				"rutas_estudio"
			)
		);
	
	const rutaActiva =
		rutasSnap.docs
			.map(
				d => d.data()
			)
			.find(
				r =>
					r.userId === usuario.uid &&
					r.activa === true
			);		

const componentesExamen =
	componentesDB
		.filter(
			c =>
			Number(
				c.ExamenID
			) ===
			Number(
				examenId
			)
		)
		.map(
			c => Number(c.ID)
		);	

		


	const simulacrosSnap =
	await getDocs(
		collection(
			db,
			"simulacros_componentes"
		)
	);


const componentesDesbloqueados =
	simulacrosSnap.docs

		.map(
			d => d.data()
		)

		.filter(
			s =>
				s.userId === usuario.uid
		)

		.map(
			s => Number(
				s.componente
			)
		);

		const temaIdsExamen =
	relaciones

		.filter(
			r =>

				r.Componentes?.some(
					id =>

						componentesDesbloqueados.includes(
							Number(id)
						)
				)
		)

		.map(
			r =>
			Number(
				r.TemaID
			)
		);
			
			const temasExamen =
			temas.filter(
				t =>
				temaIdsExamen.includes(
					Number(
						t.ID
					)
				)
			);		
			
			console.log(
				"TEMAS EXAMEN:",
				temasExamen.length
			);

			const temasRuta =
	temasExamen

		.filter(
			tema => {

				const progreso =
					progresos.find(
						p =>
						Number(
							p.temaId
						) ===
						Number(
							tema.ID
						)
					);

				const prerequisitos =
					tema.Prerrequisitos || [];

				const prerequisitosCumplidos =
					prerequisitos.every(
						preId => {

							const pre =
								progresos.find(
									p =>
									Number(
										p.temaId
									) ===
									Number(
										preId
									)
								);

							return (
								pre &&
								(pre.totalRespondidas || 0) >= 5 &&
								(
									(pre.correctas || 0) /
									Math.max(
										pre.totalRespondidas || 1,
										1
									)
								) >= 0.7
							);
						}
					);

				

				if (!progreso) {
					return true;
				}

				return (
					(progreso.totalRespondidas || 0) < 5
				);
			}
		)

		.sort(
			(a, b) =>
				(
					a.Prerrequisitos
						?.length || 0
				)
				-
				(
					b.Prerrequisitos
						?.length || 0
				)
		)

		.slice(0, 10);

const materiasRuta = {};

temasRuta.forEach(
	tema => {

		if (
			!materiasRuta[
				tema.Materia
			]
		) {

			materiasRuta[
				tema.Materia
			] = [];
		}

		materiasRuta[
			tema.Materia
		].push({

			id:
				tema.ID,

			nombre:
				tema.Tema
		});
	}
);

const rutaEstudio =
	Object.entries(
		materiasRuta
	)
	.map(
		([
			materia,
			temas
		]) => ({

			materia,

			temas
		})
	);

	const cronograma = [];

temasRuta.forEach(
	(tema, index) => {

		cronograma.push({

			semana:
				index + 1,

				horas:
	rutaActiva?.horasSemana || 10,

			temas: [
				{
					nombre:
						tema.Tema
				}
			]
		});
	}
);

	console.log(
		"RUTA ESTUDIO:",
		rutaEstudio
	);

	return {

		estudiante:
			usuario?.displayName ||
			"Estudiante",
	
		examen,
	
		fecha:
			new Date()
				.toLocaleDateString(),
	
		fortalezas,
	
		oportunidades,
	
		resumen: {
	
			temasExplorados,
	
			temasDominados
		},
	
		componentes:
			listaComponentes.map(
				([
					nombre,
					info
				]) => ({
	
					nombre,
	
					explorados:
						info.temasExplorados,
	
					dominados:
						info.temasEvaluados,
	
					estado:
						info.estado
				})
			),

			rutaEstudio,

fechaObjetivo:
	rutaActiva?.fechaObjetivo || "",

horasSemana:
	rutaActiva?.horasSemana || 0,

diasRestantes:
	rutaActiva?.diasRestantes || 0,

estadoViabilidad:
	rutaActiva?.estadoViabilidad || "",

cronograma

};
};

export default generarPlanEstudio;